"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "spaceEighth": "var(--space-eighth)",
  "spaceQuarter": "var(--space-quarter)",
  "spaceHalf": "var(--space-half)",
  "spaceThreeQuarters": "var(--space-three-quarters)",
  "spaceOne": "var(--space-one)",
  "spaceOneAndHalf": "var(--space-one-and-half)",
  "spaceTwo": "var(--space-two)",
  "spaceThree": "var(--space-three)",
  "spaceFour": "var(--space-four)",
  "fontSizeS": "var(--font-size-s)",
  "fontSizeM": "var(--font-size-m)",
  "fontSizeN": "var(--font-size-n)",
  "fontSizeL": "var(--font-size-l)",
  "fontSizeXl": "var(--font-size-xl)",
  "fontSize2xl": "var(--font-size-2xl)",
  "fontSize3xl": "var(--font-size-3xl)",
  "fontSize4xl": "var(--font-size-4xl)",
  "lineHeightS": "var(--line-height-s)",
  "lineHeightN": "var(--line-height-n)",
  "fontFamilyMain": "var(--font-family-main)",
  "fontFamilyFallback": "var(--font-family-fallback)",
  "fontFamily": "var(--font-family)",
  "radiusLight": "var(--radius-light)",
  "radiusRegular": "var(--radius-regular)",
  "radiusHeavy": "var(--radius-heavy)",
  "borderSizeLight": "var(--border-size-light)",
  "borderSizeRegular": "var(--border-size-regular)",
  "borderSizeHeavy": "var(--border-size-heavy)",
  "colorThemeTemp": "var(--color-theme-temp)",
  "colorDarkTemp": "var(--color-dark-temp)",
  "colorLightTemp": "var(--color-light-temp)"
};
exports["default"] = _default;